<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow v-for="entity in entities" :key="entity.title">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">
                            {{ entity.title }}
                        </CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="entitiesEnabled[entity.id]"
                            />
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/PartnersTabLinks';

    export default {

        name: 'PartnerEntities',
        components: {
            PartnersTabLinks,
        },

        data() {
            return {
                partner: {},
                entities: [],
                savedEntities: [],
                entitiesEnabled: [],
            };
        },

        computed: {},

        mounted() {
            const id = parseInt(this.$route.params.id);
            const code = this.$route.params.code;
            Vue.axios.get(`/partners/${id}`)
                .then(resp => {
                    const partner = resp.data;
                    if (!partner.entities) partner.entities = [];
                    this.savedEntities = partner.entities;
                    this.partner = partner;
                    Vue.axios
                        .get(`/entities/${code}`)
                        .then(resp => {
                            this.entities = resp.data;
                            this.initEntitiesEnabled();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки данных.');
                        });
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            save() {
                this.partner.entities = [];
                this.entitiesEnabled.forEach((entity, idx) => entity ? this.partner.entities.push(idx) : '');
                Vue.axios
                    .put('/partners/' + this.partner.id + '/entities', {
                        entities: this.partner.entities,
                    })
                    .then(() => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            change(e) {
                console.log(e);
            },
            initEntitiesEnabled() {
                this.entitiesEnabled = [];
                this.entities.forEach(entity => {
                    this.entitiesEnabled[entity.id] = this.partner.entities.includes(entity.id);
                });
                this.partner.entities.forEach(entity => {
                    this.entitiesEnabled[entity] = true;
                });
            },
            goBack() {
                this.$router.push({ path: '/partners/' + this.partner.id });
            },
        },
    };
</script>
